import classNames from 'classnames';
import styles from './CbGuideCard.module.css';
import { QuizContent } from './QuizContent';
import { StoryContent } from './StoryContent';
import { TitleContent } from './TitleContent';
import { VideoContent } from './VideoContent';
import { ButtonContent } from './ButtonContent';
import { useBreakpointValue } from '@chakra-ui/react';
import { Card } from 'types/Card';
import { CompletedCard } from './CompletedCard';
import { NewCard } from './NewCard';
export interface CbGuideCardProps {
  card: Card;
  visualIndex?: number;
  isActive?: boolean;
  isBuilder?: boolean;
  onAnswerQuestion?: (questionId: number, optionId: number) => Promise<void>;
}
export const CbGuideCard = ({
  card,
  visualIndex = 0,
  isActive,
  isBuilder = false,
  onAnswerQuestion
}: CbGuideCardProps) => {
  const isMobile = useBreakpointValue({
    base: true,
    md: false
  }, {
    ssr: false
  });
  const isPrev = visualIndex < 0;
  const isUpcoming = visualIndex > 3; // For cards that are < 3 cards away from the current card
  const isHidden = isPrev || isUpcoming;
  const classes = classNames(styles.guideCard, styles.readonly, {
    [styles.active]: isActive,
    [styles.desktopGuideCard]: !isMobile && !isBuilder,
    [styles.builder]: isBuilder,
    [styles.mobile]: isMobile,
    [styles.hidden]: isHidden
  });
  const scale = 1 - visualIndex * 0.1;
  const brightness = 1 - visualIndex * 0.15;
  const zIndex = isPrev ? 1000 + visualIndex : 1000 - visualIndex;
  const GuideElement = ({
    card
  }) => {
    switch (card.format) {
      case 'title':
        // If isBuilder and card has no title or description, show NewCard
        if (isBuilder && !card.title && !card.description) {
          return <NewCard />;
        }
        return <TitleContent content={card} />;
      case 'story':
        return <StoryContent content={card} />;
      case 'quiz':
        return <QuizContent content={card} isBuilder={isBuilder} onOptionSelect={onAnswerQuestion} />;
      case 'video':
        return <VideoContent content={card} isMobile={isMobile} />;
      case 'button':
        return <ButtonContent content={card} />;
      case 'completed':
        return <CompletedCard unlockedCampaigns={card.unlockedCampaigns} />;
      default:
        return <div>Unknown card type</div>;
    }
  };
  if (isMobile) {
    return <div className={classes} aria-current={isActive} aria-hidden={isHidden}>
        <GuideElement card={card} />
      </div>;
  }
  return <div className={classes} style={{
    transform: isPrev ? 'translate(0)' : `scale(${scale})`,
    filter: `brightness(${brightness})`,
    zIndex: zIndex,
    pointerEvents: card.format === 'video' && isBuilder ? 'none' : 'auto'
  }} aria-current={isActive} aria-hidden={isHidden} data-sentry-component="CbGuideCard" data-sentry-source-file="CbGuideCard.tsx">
      <GuideElement card={card} data-sentry-element="GuideElement" data-sentry-source-file="CbGuideCard.tsx" />
    </div>;
};